/**
 * Fallback Data Manager
 * Provides static/demo flight data when API limits are exceeded
 */

const FALLBACK_FLIGHTS = [
  // China-focused flights for initial display
  {
    flight: {
      iataNumber: "CA123",
      number: "123",
      icaoNumber: "CCA123"
    },
    airline: {
      iataCode: "CA",
      icaoCode: "CCA",
      name: "Air China"
    },
    departure: {
      iataCode: "PEK",
      airport: "Beijing Capital International Airport",
      city: "Beijing",
      country: "China",
      scheduledTime: "2024-01-15T10:30:00Z"
    },
    arrival: {
      iataCode: "SHA",
      airport: "Shanghai Pudong International Airport",
      city: "Shanghai",
      country: "China",
      scheduledTime: "2024-01-15T12:45:00Z"
    },
    geography: {
      latitude: 35.8617,
      longitude: 104.1954,
      altitude: 35000,
      speed: 450,
      heading: 120
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "MU456",
      number: "456",
      icaoNumber: "CES456"
    },
    airline: {
      iataCode: "MU",
      icaoCode: "CES",
      name: "China Eastern Airlines"
    },
    departure: {
      iataCode: "SHA",
      airport: "Shanghai Pudong International Airport",
      city: "Shanghai",
      country: "China",
      scheduledTime: "2024-01-15T14:20:00Z"
    },
    arrival: {
      iataCode: "CAN",
      airport: "Guangzhou Baiyun International Airport",
      city: "Guangzhou",
      country: "China",
      scheduledTime: "2024-01-15T16:30:00Z"
    },
    geography: {
      latitude: 32.0603,
      longitude: 118.7969,
      altitude: 28000,
      speed: 420,
      heading: 180
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "CZ789",
      number: "789",
      icaoNumber: "CSN789"
    },
    airline: {
      iataCode: "CZ",
      icaoCode: "CSN",
      name: "China Southern Airlines"
    },
    departure: {
      iataCode: "CAN",
      airport: "Guangzhou Baiyun International Airport",
      city: "Guangzhou",
      country: "China",
      scheduledTime: "2024-01-15T12:15:00Z"
    },
    arrival: {
      iataCode: "SZX",
      airport: "Shenzhen Bao'an International Airport",
      city: "Shenzhen",
      country: "China",
      scheduledTime: "2024-01-15T13:45:00Z"
    },
    geography: {
      latitude: 22.3193,
      longitude: 113.9140,
      altitude: 32000,
      speed: 480,
      heading: 45
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "HU321",
      number: "321",
      icaoNumber: "CHH321"
    },
    airline: {
      iataCode: "HU",
      icaoCode: "CHH",
      name: "Hainan Airlines"
    },
    departure: {
      iataCode: "PEK",
      airport: "Beijing Capital International Airport",
      city: "Beijing",
      country: "China",
      scheduledTime: "2024-01-15T09:45:00Z"
    },
    arrival: {
      iataCode: "CTU",
      airport: "Chengdu Shuangliu International Airport",
      city: "Chengdu",
      country: "China",
      scheduledTime: "2024-01-15T12:30:00Z"
    },
    geography: {
      latitude: 30.5728,
      longitude: 104.0668,
      altitude: 25000,
      speed: 380,
      heading: 270
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "3U654",
      number: "654",
      icaoNumber: "CSC654"
    },
    airline: {
      iataCode: "3U",
      icaoCode: "CSC",
      name: "Sichuan Airlines"
    },
    departure: {
      iataCode: "CTU",
      airport: "Chengdu Shuangliu International Airport",
      city: "Chengdu",
      country: "China",
      scheduledTime: "2024-01-15T08:30:00Z"
    },
    arrival: {
      iataCode: "XIY",
      airport: "Xi'an Xianyang International Airport",
      city: "Xi'an",
      country: "China",
      scheduledTime: "2024-01-15T10:20:00Z"
    },
    geography: {
      latitude: 34.3416,
      longitude: 108.9398,
      altitude: 38000,
      speed: 520,
      heading: 60
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "DL456",
      number: "456",
      icaoNumber: "DAL456"
    },
    airline: {
      iataCode: "DL",
      icaoCode: "DAL",
      name: "Delta Air Lines"
    },
    departure: {
      iataCode: "ATL",
      airport: "Hartsfield-Jackson Atlanta International Airport",
      city: "Atlanta",
      country: "United States",
      scheduledTime: "2024-01-15T14:20:00Z"
    },
    arrival: {
      iataCode: "LAX",
      airport: "Los Angeles International Airport",
      city: "Los Angeles",
      country: "United States",
      scheduledTime: "2024-01-15T16:30:00Z"
    },
    geography: {
      latitude: 33.9425,
      longitude: -118.4081,
      altitude: 28000,
      speed: 420,
      heading: 270
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "UA789",
      number: "789",
      icaoNumber: "UAL789"
    },
    airline: {
      iataCode: "UA",
      icaoCode: "UAL",
      name: "United Airlines"
    },
    departure: {
      iataCode: "ORD",
      airport: "O'Hare International Airport",
      city: "Chicago",
      country: "United States",
      scheduledTime: "2024-01-15T12:15:00Z"
    },
    arrival: {
      iataCode: "SFO",
      airport: "San Francisco International Airport",
      city: "San Francisco",
      country: "United States",
      scheduledTime: "2024-01-15T15:45:00Z"
    },
    geography: {
      latitude: 37.6213,
      longitude: -122.3790,
      altitude: 32000,
      speed: 480,
      heading: 285
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "WN321",
      number: "321",
      icaoNumber: "SWA321"
    },
    airline: {
      iataCode: "WN",
      icaoCode: "SWA",
      name: "Southwest Airlines"
    },
    departure: {
      iataCode: "DEN",
      airport: "Denver International Airport",
      city: "Denver",
      country: "United States",
      scheduledTime: "2024-01-15T09:45:00Z"
    },
    arrival: {
      iataCode: "PHX",
      airport: "Phoenix Sky Harbor International Airport",
      city: "Phoenix",
      country: "United States",
      scheduledTime: "2024-01-15T11:30:00Z"
    },
    geography: {
      latitude: 33.4342,
      longitude: -112.0116,
      altitude: 25000,
      speed: 380,
      heading: 200
    },
    status: "en-route"
  },
  {
    flight: {
      iataNumber: "BA654",
      number: "654",
      icaoNumber: "BAW654"
    },
    airline: {
      iataCode: "BA",
      icaoCode: "BAW",
      name: "British Airways"
    },
    departure: {
      iataCode: "LHR",
      airport: "London Heathrow Airport",
      city: "London",
      country: "United Kingdom",
      scheduledTime: "2024-01-15T08:30:00Z"
    },
    arrival: {
      iataCode: "JFK",
      airport: "John F. Kennedy International Airport",
      city: "New York",
      country: "United States",
      scheduledTime: "2024-01-15T14:20:00Z"
    },
    geography: {
      latitude: 40.6892,
      longitude: -74.1745,
      altitude: 38000,
      speed: 520,
      heading: 270
    },
    status: "en-route"
  }
];

class FallbackDataManager {
  constructor() {
    this.isFallbackMode = false;
    this.fallbackReason = null;
    this.cachedRealFlights = [];
    this.lastCacheUpdate = 0;
  }

  /**
   * Enable fallback mode
   */
  enableFallback(reason = 'API_LIMIT_EXCEEDED') {
    this.isFallbackMode = true;
    this.fallbackReason = reason;
    console.warn(`🔄 Fallback mode enabled: ${reason}`);
  }

  /**
   * Disable fallback mode
   */
  disableFallback() {
    this.isFallbackMode = false;
    this.fallbackReason = null;
    console.log('✅ Fallback mode disabled');
  }

  /**
   * Store real flight data for fallback use
   */
  storeRealFlights(flights) {
    if (Array.isArray(flights) && flights.length > 0) {
      this.cachedRealFlights = flights;
      this.lastCacheUpdate = Date.now();
      console.log(`📦 Stored ${flights.length} real flights for fallback use`);
    }
  }

  /**
   * Get initial dummy flights for immediate display (China-focused)
   */
  getInitialDummyFlights(count = 500) {
    console.log(`🛩️ Showing ${count} initial dummy flights in China area`);
    return this.getDemoFlights(count);
  }

  /**
   * Get fallback flight data - prefers cached real data over demo data
   */
  getFallbackFlights(count = 5000) {
    if (!this.isFallbackMode) {
      return [];
    }

    // First try to use cached real flight data
    if (this.cachedRealFlights.length > 0) {
      const cacheAge = Date.now() - this.lastCacheUpdate;
      const maxCacheAge = 30 * 60 * 1000; // 30 minutes
      
      if (cacheAge < maxCacheAge) {
        console.log(`🔄 Using ${this.cachedRealFlights.length} cached real flights for fallback`);
        
        // If we need more flights than cached, duplicate and modify cached flights
        if (count > this.cachedRealFlights.length) {
          const flights = [...this.cachedRealFlights];
          const baseFlights = [...this.cachedRealFlights];
          
          for (let i = this.cachedRealFlights.length; i < count; i++) {
            const baseFlight = baseFlights[i % baseFlights.length];
            const flight = {
              ...baseFlight,
              flight: {
                ...baseFlight.flight,
                iataNumber: `${baseFlight.flight.iataNumber.slice(0, 2)}${String(i + 1).padStart(3, '0')}`,
                number: String(i + 1)
              },
              geography: {
                ...baseFlight.geography,
                latitude: baseFlight.geography.latitude + (Math.random() - 0.5) * 2,
                longitude: baseFlight.geography.longitude + (Math.random() - 0.5) * 2,
                altitude: baseFlight.geography.altitude + (Math.random() - 0.5) * 2000,
                speed: baseFlight.geography.speed + (Math.random() - 0.5) * 50,
                heading: (baseFlight.geography.heading + Math.random() * 20 - 10) % 360
              }
            };
            flights.push(flight);
          }
          
          return flights.slice(0, count);
        }
        
        return this.cachedRealFlights.slice(0, count);
      }
    }

    // Fallback to demo flights if no cached real data
    console.log('🔄 No cached real flights available, using demo flights');
    return this.getDemoFlights(count);
  }

  /**
   * Generate demo flights (used when no real data is available)
   */
  getDemoFlights(count = 5000) {
    const flights = [];
    const baseFlights = [...FALLBACK_FLIGHTS];
    
    // Add more realistic flight routes
    const additionalRoutes = [
      { dep: 'DFW', arr: 'LAX', lat: 32.8968, lng: -97.0380 },
      { dep: 'MIA', arr: 'JFK', lat: 25.7617, lng: -80.1918 },
      { dep: 'SEA', arr: 'ORD', lat: 47.6062, lng: -122.3321 },
      { dep: 'LAS', arr: 'DEN', lat: 36.1699, lng: -115.1398 },
      { dep: 'PHL', arr: 'ATL', lat: 39.9526, lng: -75.1652 },
      { dep: 'BOS', arr: 'MIA', lat: 42.3601, lng: -71.0589 },
      { dep: 'SLC', arr: 'SFO', lat: 40.7608, lng: -111.8910 },
      { dep: 'MSP', arr: 'PHX', lat: 44.9778, lng: -93.2650 },
      { dep: 'DTW', arr: 'LAS', lat: 42.3314, lng: -83.0458 },
      { dep: 'CLT', arr: 'DEN', lat: 35.2271, lng: -80.8431 }
    ];
    
    const allRoutes = [...baseFlights, ...additionalRoutes.map(route => ({
      flight: { iataNumber: `${route.dep}${Math.floor(Math.random() * 999)}`, number: Math.floor(Math.random() * 999) },
      airline: { iataCode: route.dep.slice(0, 2), name: 'Demo Airline' },
      departure: { iataCode: route.dep, city: route.dep },
      arrival: { iataCode: route.arr, city: route.arr },
      geography: { latitude: route.lat, longitude: route.lng, altitude: 30000 + Math.random() * 10000, speed: 400 + Math.random() * 200, heading: Math.random() * 360 },
      status: 'en-route'
    }))];
    
    for (let i = 0; i < count; i++) {
      const baseFlight = allRoutes[i % allRoutes.length];
      const flight = {
        ...baseFlight,
        flight: {
          ...baseFlight.flight,
          iataNumber: `${baseFlight.flight.iataNumber.slice(0, 2)}${String(i + 1).padStart(3, '0')}`,
          number: String(i + 1)
        },
        geography: {
          ...baseFlight.geography,
          latitude: baseFlight.geography.latitude + (Math.random() - 0.5) * 4,
          longitude: baseFlight.geography.longitude + (Math.random() - 0.5) * 4,
          altitude: baseFlight.geography.altitude + (Math.random() - 0.5) * 5000,
          speed: baseFlight.geography.speed + (Math.random() - 0.5) * 100,
          heading: (baseFlight.geography.heading + Math.random() * 360) % 360
        }
      };
      flights.push(flight);
    }

    return flights;
  }

  /**
   * Get fallback airline data
   */
  getFallbackAirlines() {
    if (!this.isFallbackMode) {
      return [];
    }

    return [
      {
        iataCode: "AA",
        icaoCode: "AAL",
        nameAirline: "American Airlines",
        statusAirline: "active"
      },
      {
        iataCode: "DL",
        icaoCode: "DAL",
        nameAirline: "Delta Air Lines",
        statusAirline: "active"
      },
      {
        iataCode: "UA",
        icaoCode: "UAL",
        nameAirline: "United Airlines",
        statusAirline: "active"
      },
      {
        iataCode: "WN",
        icaoCode: "SWA",
        nameAirline: "Southwest Airlines",
        statusAirline: "active"
      },
      {
        iataCode: "BA",
        icaoCode: "BAW",
        nameAirline: "British Airways",
        statusAirline: "active"
      }
    ];
  }

  /**
   * Check if we should use fallback data
   */
  shouldUseFallback(error) {
    if (this.isFallbackMode) {
      return true;
    }

    // Check for specific error conditions
    if (error && (
      error.message?.includes('limit exceed') ||
      error.message?.includes('rate limit') ||
      error.message?.includes('429') ||
      error.message?.includes('quota') ||
      error.status === 429 ||
      error.status === 403
    )) {
      this.enableFallback('API_LIMIT_EXCEEDED');
      return true;
    }

    return false;
  }

  /**
   * Get fallback status message
   */
  getFallbackMessage() {
    if (!this.isFallbackMode) {
      return null;
    }

    // Check if we have cached real data
    const cacheAge = Date.now() - this.lastCacheUpdate;
    const maxCacheAge = 30 * 60 * 1000; // 30 minutes
    
    if (this.cachedRealFlights.length > 0 && cacheAge < maxCacheAge) {
      const ageMinutes = Math.floor(cacheAge / (60 * 1000));
      return `Using cached flight data (${ageMinutes}m old)`;
    }

    switch (this.fallbackReason) {
      case 'API_LIMIT_EXCEEDED':
        return 'API limit exceeded. Showing demo data.';
      case 'NETWORK_ERROR':
        return 'Network error. Showing demo data.';
      default:
        return 'Using demo flight data.';
    }
  }

  /**
   * Reset fallback mode after successful API call
   */
  resetOnSuccess() {
    if (this.isFallbackMode) {
      // Only reset after a few successful calls
      setTimeout(() => {
        this.disableFallback();
      }, 30000); // 30 seconds delay
    }
  }
}

// Create singleton instance
const fallbackManager = new FallbackDataManager();

export default fallbackManager;
